/**
 * Main pipe module for custom BCX Pipes
 *
 * @version
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022 Build Centrix
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BcxBytesPipe } from './bytes/bytes.pipe';
import { BcxCurrencyPipe } from './currency/currency.pipe';
import { BcxTimePipe } from './time/time.pipe';
import { BcxWeightPipe } from './weight/weight.pipe';

@NgModule({
  declarations: [BcxBytesPipe, BcxCurrencyPipe, BcxTimePipe, BcxWeightPipe],
  imports: [CommonModule],
  exports: [BcxBytesPipe, BcxCurrencyPipe, BcxTimePipe, BcxWeightPipe],
  providers: [BcxBytesPipe, BcxCurrencyPipe, BcxTimePipe, BcxWeightPipe],
})
export class MainPipe {}
